import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { TruckEntity } from 'src/entities/truckEntity';
import { dataGridUtil } from 'src/utils/dataGrid.util';

export const Columns: (
  unit: string,
  openEditDialog?: (truckEntity: TruckEntity) => void
) => GridColDef[] = (
  unit,
  openEditDialog
) => {
  const getWidth = (name: string, width: number) => {
    const maybeWidth: number = dataGridUtil.getSavedColumnWidth('truck-columns', name);

    return maybeWidth || width;
  };

  const editColumn: GridColDef | null = openEditDialog ? {
    field: 'edit',
    headerName: '編集',
    disableExport: true,
    renderCell: (params: { row: TruckEntity }) => (
      <IconButton onClick={() => openEditDialog(params.row)}>
        <EditOutlinedIcon />
      </IconButton>
    ),
    width: 70,
    sortable: false,
    filterable: false,
  } : null;

  return [
    editColumn,
    {
      field: 'company_name',
      headerName: '事業所',
      width: getWidth('company_name', 200),
    },
    {
      field: 'garage_name',
      headerName: '車庫',
      width: getWidth('garage', 200),
    },
    {
      field: 'garage_address',
      headerName: '車庫住所',
      width: getWidth('garage_address', 100),
    },
    { field: 'license_plate_value', headerName: 'トラック', width: getWidth('license_plate_value', 320) },
    {
      field: 'truck_number',
      headerName: '車番',
      width: getWidth('truck_namber', 200),
    },
    {
      field: 'partner_company_name',
      headerName: '運送会社',
      width: getWidth('partner_company_name', 200),
    },
    {
      field: 'maximum_loading_capacity_kg',
      headerName: `最大積載量(${unit})`,
      width: getWidth('maximum_loading_capacity_kg', 130),
      type: 'number' as const,
    },
    {
      field: 'maximum_loading_rate',
      headerName: '積載率上限',
      width: getWidth('maximum_loading_rate', 100),
      type: 'number' as const,
    },
    {
      field: 'minimum_loading_rate',
      headerName: '積載率下限',
      width: getWidth('minimum_loading_rate', 100),
      type: 'number' as const,
    },
    {
      field: 'loading_platform_volume_m3',
      headerName: '最大積載量(m3)',
      width: getWidth('loading_platform_volume_m3', 160),
      type: 'number' as const,
    },
    {
      field: 'maximum_loading_capacity_quantity',
      headerName: '最大積載量(数量)',
      width: getWidth('maximum_loading_capacity_quantity', 140),
      type: 'number' as const,
    },
    { field: 'car_model', headerName: '車種', width: getWidth('car_model', 160) },
    { field: 'klass', headerName: '車両タイプ', width: getWidth('klass', 160) },
    { field: 'floor_specification', headerName: '床仕様', width: getWidth('floor_specification', 150) },
    { field: 'loading_platform_height', headerName: '荷台高の種別', width: getWidth('loading_platform_height', 150) },
    { field: 'loading_platform_length', headerName: '荷台長の種別', width: getWidth('loading_platform_length', 150) },
    { field: 'loading_platform_width', headerName: '荷台幅の種別', width: getWidth('loading_platform_width', 150) },
    {
      field: 'features',
      headerName: '装置',
      width: getWidth('features', 300),
      valueFormatter: (params: string[]) => {
        if (!params) { return ''; }

        if (!params || params.length === 0 || params.length === 1) { // CSVに出力する場合
          return params;
        }
        return `"${params.join(',')}"`;
      },
      renderCell: (params: { row: TruckEntity }) => { // 画面に表示する場合
        if (!params.row.features) { return ''; }
        return params.row.features.join(',');
      }
    },
    {
      field: 'truck_fuel_cost_yen_per_km',
      headerName: '1kmあたりの燃料費',
      width: getWidth('truck_fuel_cost_yen_per_km', 150),
      type: 'number' as const,
    },
    {
      field: 'truck_insurance_fee_yen_per_day',
      headerName: '1日あたりの保険料',
      width: getWidth('truck_insurance_fee_yen_per_day', 150),
      type: 'number' as const,
    },
    {
      field: 'truck_repair_cost_yen_per_day',
      headerName: '1日あたりの修繕費',
      width: getWidth('truck_repair_cost_yen_per_day', 150),
      type: 'number' as const,
    },
    {
      field: 'truck_expressway_fee_yen_per_shift',
      headerName: '1日あたりの高速代',
      width: getWidth('truck_expressway_fee_yen_per_shift', 150),
      type: 'number' as const,
    },
    {
      field: 'max_num_pistons',
      headerName: '最大回転数',
      width: getWidth('max_num_pistons', 150),
      type: 'number' as const,
    },
    {
      field: 'max_num_locations_per_pistons',
      headerName: '1回転あたりの最大納品先件数',
      width: getWidth('max_num_locations_per_pistons', 150),
      type: 'number' as const,
    },
    {
      field: 'sort_order',
      headerName: '並び順',
      width: getWidth('sort_order', 100),
      type: 'number' as const,
    },
  ].filter((maybe) => !!maybe);
};
